import React from "react";
import Ribbon from "~/common/Ribbon/primitive";
import { cls } from "@wss/cls";
{
  /*
  Depending on the size of the bounding box of the SVG/Icon there may
  be some adjusting needed to properly align the icon.
  The `-ml-[3px]` is an example adjustment for pulling back some space from the right
  of the ribbon because the width of SVG bounding box makes it appear that there is
  more padding on the right side of the ribbon than there actually is.
   Usage ex:
    <RibbonWithIcon
      className="bg-customPurple-200 text-white"
      iconPosition="right"
      icon={
        <Icon
          name="ri-arrow-right-double-line"
          theme="wss"
          className="fill-white -mr-[4px]"
          size="xsmall"
        />
      onIconClick={() => alert("Plus ribbon clicked")}
      }
    >
      Hello
    </RibbonWithIcon>
  */
}
type IconRibbonRootProps = {
  icon: React.ReactNode;
  iconPosition?: "left" | "right";
  onIconClick?: () => void;
  children: React.ReactNode;
  as?: "div" | "a" | "button";
} & React.HTMLAttributes<HTMLDivElement> & React.AnchorHTMLAttributes<HTMLAnchorElement> & React.ButtonHTMLAttributes<HTMLButtonElement>;
const RibbonWithIcon = ({
  as = "div",
  children,
  className,
  icon,
  iconPosition = "right",
  onIconClick,
  ...otherProps
}: IconRibbonRootProps) => {
  return <Ribbon as={as} className={className} enhancerClasses={cls("flex flex-row items-center")} {...otherProps} data-sentry-element="Ribbon" data-sentry-component="RibbonWithIcon" data-sentry-source-file="ribbonWithIcon.tsx">
      <span {...onIconClick && {
      onClick: onIconClick
    }} style={{
      pointerEvents: "auto"
    }} className={cls("cursor-pointer inline-flex items-center", iconPosition === "left" ? "order-1" : "order-2")}>
        {icon}
      </span>

      <span className={cls("inline-flex items-center", iconPosition === "left" ? "order-2" : "order-1")}>
        {children}
      </span>
    </Ribbon>;
};
export default RibbonWithIcon;